function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 12C2 6.48 6.47 2 11.99 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 11.99 22C6.47 22 2 17.52 2 12ZM4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12Z",
  fill: "#FF9500",
  fillOpacity: 0.7
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3109 6.31995C10.4509 6.31995 8.92091 6.97995 7.93091 8.19495L9.47591 9.63495C10.2109 8.80995 11.1109 8.38995 12.1909 8.38995C13.6909 8.38995 14.8159 9.31995 15.1609 10.7599H10.9309V12.6199H15.1909C14.8759 14.1199 13.7359 15.1099 12.1909 15.1099C11.1109 15.1099 10.2109 14.6899 9.47591 13.8649L7.93091 15.3049C8.92091 16.5199 10.4509 17.1799 12.3109 17.1799C15.4609 17.1799 17.7559 14.9149 17.7559 11.7499C17.7559 8.58495 15.4609 6.31995 12.3109 6.31995Z",
  fill: "#FF9500",
  fillOpacity: 0.7
});

var SvgExpert24 = function SvgExpert24(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExpert24, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/expert_24.d86d9b51.svg";
export { ForwardRef as ReactComponent };